import "../src/utils/parseJson"
import 'react-app-polyfill/ie11';

import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.scss";
import "./map-custom.css";
import store from "./redux/store";
import { Provider } from "react-redux";
import embLabels from "./config/emb-labels-en.json";
// applyPolyfills().then(() => {
//   defineCustomElements(window);
// });
/* estlint no-restricted-globals:0 */
let state = {};
const container = document.getElementById("root");
window.setState = changes => {
  state = Object.assign({}, state, changes);
  ReactDOM.render(<Provider store={store}><App {...state} /></Provider>, container);
};

let initialState = {
  location: window.location.pathname.replace(/("\/?|\/$)/g, ""),
};
window.setState(initialState);

// Set document title from resource bundle or environment at runtime
try {
  const defaultTitle = process.env.REACT_APP_DEFAULT_TITLE || "";
  const bundleTitle = embLabels?.appTitle || "";
  const title = bundleTitle || defaultTitle || document.title;
  if (title) document.title = title;
} catch (e) {
  // fail silently if labels not available
}
